import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted Inter font (replaces the Google Fonts CDN link so no visitor IP
// is sent to Google just to load fonts). Weights match the previous CDN request.
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import ConsentedAnalytics from './lib/analytics';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    {/* Analytics render only after the visitor accepts cookies. */}
    <ConsentedAnalytics />
  </StrictMode>,
);
